<template>
  <div v-loading="loading" @click="onClick">
    <img v-if="form.imageId" class="rounded" style="cursor: pointer;" width="100%" :src="`https://ucarecdn.com/${ form.imageId }/-/scale_crop/300x300/center/-/quality/lighter/`">
    <img v-else class="rounded" style="cursor: pointer;" width="100%" src="@/assets/images/placeholder-1-1.png">
  </div>
</template>

<script>
import uploadcare from 'uploadcare-widget'

export default {
  data() {
    return {
      loading: false,
      form: {
        imageId: this.brand.image_id,
      }
    }
  },

  props: {
    brand: Object,
  },

  methods: {
    async onClick() {
      var dialog = uploadcare.openDialog(null, {
        publicKey: process.env.VUE_APP_UPLOADCARE,
        imagesOnly: true,
        imageShrink: '600x600',
      })

      try {
        var result = await dialog.done()
      } catch(err) {
        return false
      }

      this.onSubmit(result.uuid)
    },

    async onSubmit(imageId) {
      this.loading = true

      try {
        var { data } = await this.$http.put(`/brands/${ this.brand.id }`, {
          image_id: imageId,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.form.imageId = imageId
      this.$message.success(data.message)
    },
  },
}
</script>
